// extracted by mini-css-extract-plugin
module.exports = {"colorLight":"#F9F9F9"};